// File: components/renderer/player/parts.ts
export const drawBraid = (ctx: CanvasRenderingContext2D, breath: number, sway: number) => {
  ctx.save();
  ctx.rotate((sway * Math.PI) / 180);
  
  const braidGrad = ctx.createLinearGradient(0, 0, 0, 120);
  braidGrad.addColorStop(0, "#9b59b6");
  braidGrad.addColorStop(0.5, "#8e44ad");
  braidGrad.addColorStop(1, "#5b2c6f");

  for (let i = 0; i < 8; i++) {
    const size = 16 - i * 1.2;
    const yPos = i * 12;
    const offset = Math.sin(i * 0.8) * 3;
    ctx.fillStyle = braidGrad;
    ctx.beginPath();
    ctx.ellipse(offset, yPos, size, size * 0.8, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = "rgba(255,255,255,0.15)";
    ctx.beginPath();
    ctx.ellipse(offset - 4, yPos - 4, size/3, size/3, 0, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.fillStyle = "#f1c40f"; ctx.fillRect(-6, 90, 12, 6);
  ctx.fillStyle = "#8e44ad"; ctx.beginPath(); ctx.moveTo(-4, 96); ctx.lineTo(4, 96); ctx.lineTo(0, 115); ctx.fill();
  ctx.restore();
};

export const drawLegs = (ctx: CanvasRenderingContext2D, skinGrad: CanvasGradient, walkSway: number) => {
  // Left Leg
  ctx.save();
  ctx.translate(5, -85);
  ctx.rotate((-walkSway * 0.5 * Math.PI) / 180);
  ctx.fillStyle = skinGrad;
  ctx.beginPath(); ctx.moveTo(-6, 0); ctx.lineTo(6, 0); ctx.lineTo(5, 40); ctx.lineTo(-5, 40); ctx.fill();
  ctx.beginPath(); ctx.moveTo(-5, 40); ctx.lineTo(5, 40); ctx.lineTo(3, 80); ctx.lineTo(-3, 80); ctx.fill();
  ctx.fillStyle = "#1a1a1a";
  ctx.beginPath(); ctx.moveTo(-4, 60); ctx.lineTo(4, 60); ctx.lineTo(4, 85); ctx.lineTo(-8, 85); ctx.lineTo(-8, 80); ctx.fill();
  ctx.fillStyle = "#333"; ctx.fillRect(-8, 83, 13, 3);
  ctx.restore();

  // Right Leg
  ctx.save();
  ctx.translate(-8, -85);
  ctx.rotate((walkSway * 0.5 * Math.PI) / 180);
  ctx.fillStyle = skinGrad;
  ctx.beginPath(); ctx.moveTo(-6, 0); ctx.lineTo(6, 0); ctx.lineTo(5, 40); ctx.lineTo(-5, 40); ctx.fill();
  ctx.beginPath(); ctx.moveTo(-5, 40); ctx.lineTo(5, 40); ctx.lineTo(3, 80); ctx.lineTo(-3, 80); ctx.fill();
  ctx.fillStyle = "#1a1a1a";
  ctx.beginPath(); ctx.moveTo(-4, 60); ctx.lineTo(4, 60); ctx.lineTo(4, 85); ctx.lineTo(-8, 85); ctx.lineTo(-8, 80); ctx.fill();
  ctx.fillStyle = "#333"; ctx.fillRect(-8, 83, 13, 3);
  ctx.restore();
};

export const drawShorts = (ctx: CanvasRenderingContext2D, breath: number) => {
  ctx.save();
  ctx.translate(0, breath);
  const denimGrad = ctx.createLinearGradient(-20, -100, 20, -85);
  denimGrad.addColorStop(0, "#2c3e50"); denimGrad.addColorStop(0.5, "#34495e"); denimGrad.addColorStop(1, "#2c3e50");
  ctx.fillStyle = denimGrad;
  ctx.beginPath(); ctx.roundRect(-16, -105, 30, 25, 4); ctx.fill();
  ctx.fillStyle = "#111"; ctx.fillRect(-16, -105, 30, 5);
  ctx.fillStyle = "#f1c40f"; ctx.fillRect(-2, -106, 6, 7);
  ctx.strokeStyle = "#5d6d7e"; ctx.lineWidth = 1;
  ctx.beginPath(); ctx.moveTo(-10, -95); ctx.lineTo(-4, -85); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(10, -95); ctx.lineTo(4, -85); ctx.stroke();
  ctx.restore();
};

export const drawNeck = (ctx: CanvasRenderingContext2D, skinGrad: CanvasGradient) => {
  ctx.fillStyle = skinGrad;
  ctx.fillRect(-4, -5, 8, 10); 
};

export const drawTorso = (ctx: CanvasRenderingContext2D, skinGrad: CanvasGradient) => {
  ctx.fillStyle = skinGrad; ctx.fillRect(-14, -125, 26, 20);
  ctx.fillStyle = "#ecf0f1";
  ctx.beginPath(); ctx.moveTo(-14, -145); ctx.lineTo(12, -145); ctx.lineTo(14, -125); ctx.lineTo(-16, -125); ctx.fill();
  ctx.fillStyle = "rgba(0,0,0,0.05)";
  ctx.beginPath(); ctx.moveTo(-14, -125); ctx.lineTo(12, -125); ctx.lineTo(0, -135); ctx.fill();
  ctx.strokeStyle = "#f39c12"; ctx.lineWidth = 2;
  ctx.beginPath(); ctx.arc(0, -150, 10, 0, Math.PI); ctx.stroke();
  ctx.fillStyle = "#f1c40f"; ctx.beginPath(); ctx.arc(0, -140, 3, 0, Math.PI * 2); ctx.fill();
};

export const drawJacket = (ctx: CanvasRenderingContext2D, skinGrad: CanvasGradient, isSwinging: boolean) => {
  const jacketGrad = ctx.createLinearGradient(-25, -150, 25, -120);
  jacketGrad.addColorStop(0, "#f39c12"); jacketGrad.addColorStop(0.4, "#f1c40f"); jacketGrad.addColorStop(1, "#f39c12");

  // Left Arm
  ctx.save();
  ctx.translate(-18, -145);
  ctx.rotate(15 * Math.PI / 180);
  ctx.fillStyle = jacketGrad; ctx.beginPath(); ctx.roundRect(-8, 0, 16, 50, 5); ctx.fill();
  ctx.fillStyle = "#111"; ctx.fillRect(-7, 45, 14, 5);
  ctx.fillStyle = skinGrad; ctx.beginPath(); ctx.arc(0, 54, 5, 0, Math.PI * 2); ctx.fill();
  ctx.restore();

  // Right Arm
  ctx.save();
  ctx.translate(16, -145);
  ctx.rotate(isSwinging ? -45 * Math.PI / 180 : -15 * Math.PI / 180);
  ctx.fillStyle = jacketGrad; ctx.beginPath(); ctx.roundRect(-8, 0, 16, 50, 5); ctx.fill();
  ctx.fillStyle = "#111"; ctx.fillRect(-7, 45, 14, 5);
  ctx.fillStyle = skinGrad; ctx.beginPath(); ctx.arc(0, 54, 5, 0, Math.PI * 2); ctx.fill();
  ctx.restore();

  // Body
  ctx.fillStyle = jacketGrad;
  ctx.beginPath(); ctx.moveTo(-20, -150); ctx.lineTo(-8, -150); ctx.lineTo(-12, -115); ctx.lineTo(-22, -115); ctx.fill();
  ctx.beginPath(); ctx.moveTo(18, -150); ctx.lineTo(6, -150); ctx.lineTo(10, -115); ctx.lineTo(20, -115); ctx.fill();
  ctx.fillStyle = "#e74c3c"; ctx.fillRect(-18, -140, 6, 8);
};

export const drawHead = (ctx: CanvasRenderingContext2D, skinGrad: CanvasGradient, isPhaseTwo: boolean = false) => {
  ctx.fillStyle = skinGrad;
  ctx.beginPath(); 
  ctx.moveTo(-11, -25); 
  ctx.quadraticCurveTo(-12, -8, -3, 0); 
  ctx.lineTo(3, 0);
  ctx.quadraticCurveTo(12, -8, 11, -25); 
  ctx.lineTo(11, -35); ctx.lineTo(-11, -35); 
  ctx.fill();
  
  ctx.fillStyle = "rgba(255, 105, 180, 0.2)";
  ctx.beginPath(); ctx.ellipse(-6, -12, 3, 2, 0, 0, Math.PI*2); ctx.fill();
  ctx.beginPath(); ctx.ellipse(6, -12, 3, 2, 0, 0, Math.PI*2); ctx.fill();

  ctx.fillStyle = "#fff";
  ctx.beginPath(); ctx.ellipse(-5, -16, 3.5, 2.5, 0, 0, Math.PI*2); ctx.fill();
  ctx.beginPath(); ctx.ellipse(5, -16, 3.5, 2.5, 0, 0, Math.PI*2); ctx.fill();
  
  // Rumi Heterochromia Logic:
  // Character's Right Eye (Viewer's Left): Always dark brown
  ctx.fillStyle = "#3e2723";
  ctx.beginPath(); ctx.arc(-5, -16, 1.8, 0, Math.PI*2); ctx.fill();
  
  // Character's Left Eye (Viewer's Right): Brown/Amber normally, Gold in Phase Two
  const normalLeftEyeColor = "#92400e"; // Deep amber brown
  const awakenedLeftEyeColor = "#fbbf24"; // Bright gold
  
  ctx.fillStyle = isPhaseTwo ? awakenedLeftEyeColor : normalLeftEyeColor; 
  ctx.beginPath(); ctx.arc(5, -16, 1.8, 0, Math.PI*2); ctx.fill();
  
  ctx.fillStyle = "#fff";
  ctx.beginPath(); ctx.arc(-4.5, -17, 0.8, 0, Math.PI*2); ctx.fill();
  ctx.beginPath(); ctx.arc(5.5, -17, 0.8, 0, Math.PI*2); ctx.fill();

  ctx.strokeStyle = "#111"; ctx.lineWidth = 0.8;
  ctx.beginPath(); ctx.moveTo(-8, -17); ctx.quadraticCurveTo(-5, -20, -2, -16); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(8, -17); ctx.quadraticCurveTo(5, -20, 2, -16); ctx.stroke();
  ctx.strokeStyle = "#5b2c6f"; ctx.lineWidth = 1;
  ctx.beginPath(); ctx.moveTo(-9, -21); ctx.lineTo(-3, -22); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(9, -21); ctx.lineTo(3, -22); ctx.stroke();
  ctx.fillStyle = "#d35400"; ctx.globalAlpha = 0.3; ctx.beginPath(); ctx.arc(0, -11, 1, 0, Math.PI*2); ctx.fill(); ctx.globalAlpha = 1.0;
  ctx.fillStyle = "#c0392b"; ctx.beginPath(); ctx.ellipse(0, -7, 2.5, 1.5, 0, 0, Math.PI*2); ctx.fill();
  ctx.fillStyle = "#e74c3c"; ctx.beginPath(); ctx.arc(0, -7.5, 1, 0, Math.PI*2); ctx.fill();
};

export const drawFrontHair = (ctx: CanvasRenderingContext2D) => {
  const hairGrad = ctx.createLinearGradient(0, -50, 0, -10);
  hairGrad.addColorStop(0, "#af7ac5"); hairGrad.addColorStop(1, "#8e44ad");
  ctx.fillStyle = hairGrad;
  ctx.beginPath();
  ctx.moveTo(-12, -30); ctx.quadraticCurveTo(-5, -55, 5, -55); ctx.quadraticCurveTo(12, -55, 12, -30);
  ctx.quadraticCurveTo(14, -10, 8, -25); ctx.lineTo(0, -32); ctx.lineTo(-8, -25);
  ctx.quadraticCurveTo(-14, -10, -12, -30); ctx.fill();
  ctx.fillStyle = "rgba(255,255,255,0.2)";
  ctx.beginPath(); ctx.ellipse(0, -45, 6, 3, 0, 0, Math.PI*2); ctx.fill();
};